import React, { useMemo } from 'react';
import { Atividade } from '../../models/atividade';
import { useMaestroContext } from '../../context/MaestroContext';
import { formatarData } from '../../utils/formatters';
import { LABEL_AREA } from '../../utils/labels';
import Card from '../Card';
import EstadoVazio from '../EstadoVazio';
import RiscoBadge from '../RiscoBadge';
import StatusBadge from '../StatusBadge';

interface VisaoLinhaDoTempoProps {
  atividades: Atividade[];
  onSelecionar: (id: number) => void;
}

const VisaoLinhaDoTempo: React.FC<VisaoLinhaDoTempoProps> = ({ atividades, onSelecionar }) => {
  const { getArea, getEmpresa } = useMaestroContext();
  const grupos = useMemo(() => {
    // Atividades sem dataPrevista ficariam agrupadas sob uma data em branco (formatarData('') === '') —
    // excluídas daqui pelo mesmo motivo do Gantt (VisaoGantt.tsx): sem posicioná-las corretamente.
    const tarefas = atividades.filter(a => a.nivelHierarquico === 'TAREFA' && a.dataPrevista).sort((a, b) => a.dataPrevista.localeCompare(b.dataPrevista));
    const mapa = new Map<string, Atividade[]>();
    tarefas.forEach(a => mapa.set(a.dataPrevista, [...(mapa.get(a.dataPrevista) ?? []), a]));
    return Array.from(mapa.entries());
  }, [atividades]);

  if (grupos.length === 0) return <EstadoVazio titulo='Nenhuma atividade para exibir na linha do tempo' />;

  return (
    <Card title='Linha do Tempo' subtitle='Atividades do ciclo, em ordem cronológica de prazo previsto.'>
      <div className='mc-timeline'>
        {grupos.map(([data, itens]) => (
          <div className='mc-timeline__grupo' key={data}>
            <div className='mc-timeline__data'>{formatarData(data)}</div>
            <div className='mc-timeline__linha' />
            <div className='mc-timeline__itens'>
              {itens.map(a => {
                const area = getArea(a.areaId);
                const empresa = getEmpresa(a.empresaId);
                return (
                  <button type='button' className='mc-timeline__item' key={a.id} onClick={() => onSelecionar(a.id)}>
                    <strong>{a.caminhoCritico && <i className='bi bi-lightning-charge-fill mc-icone-critico' />} {a.nome}</strong>
                    <small>{empresa?.nome} · {area ? LABEL_AREA[area.tipo] : ''}</small>
                    <div className='mc-timeline__badges'><StatusBadge status={a.status} /><RiscoBadge criticidade={a.criticidade} /></div>
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default VisaoLinhaDoTempo;
